import React from "react";
import StrokeNavIcon from "@Components/Icons/Nav/StrokeNavIcon";
export default ({ className }) => (React.createElement(StrokeNavIcon, { className: className, viewBox: "0 0 18.5 18.5", paths: [
        "M17.5 17.5L12.0001 12M13.8333 7.41667C13.8333 10.9605 10.9605 13.8333 7.41667 13.8333C3.87284 13.8333 1 10.9605 1 7.41667C1 3.87284 3.87284 1 7.41667 1C10.9605 1 13.8333 3.87284 13.8333 7.41667Z",
    ] }));
